import { render, staticRenderFns } from "./ItsBaseSubjectTemplateDetail.vue?vue&type=template&id=eedc2e20&scoped=true&"
import script from "./ItsBaseSubjectTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./ItsBaseSubjectTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedc2e20",
  null
  
)

export default component.exports